import React from "react";
import PolicyLayout from "./PolicyLayout";

function ConsumerDataRights() {
  return (
    <PolicyLayout
      title="Consumer data rights"
      intro="This procedure is for a person seeking access to or correction of personal data connected with the mavormira storefront."
    >
      <section>
        <h2>Access and correction requests</h2>
        <p>You may ask whether personal data about you is held, request a copy of data that can be located, or request correction of data that is inaccurate. Describe the cart, checkout, payment session or support exchange concerned and give the email or order number used. Do not send full card details.</p>
        <p>A correction request should identify the inaccurate entry, the replacement information and the reason it is accurate. Access does not extend to another person's data or material that the law permits or requires to be withheld.</p>
      </section>

      <section>
        <h2>Verification and response period</h2>
        <p>We will verify that the requester is the data subject or an authorised representative before releasing or changing personal data. Verification will be limited to what is reasonably needed for the request. A valid data access request, and a valid correction request following access, will be handled within 40 calendar days as required by Hong Kong's Personal Data (Privacy) Ordinance. If the request cannot be completed within that period for a permitted reason, the requester will be notified in writing within the same period and the work will continue as soon as practicable.</p>
      </section>

      <section>
        <h2>Limits, copies and refusal</h2>
        <p>Where applicable, we may ask that a formal request use the prescribed Hong Kong data-access form. Any permitted copy charge will be stated before the copy is supplied and will not be excessive. If access or correction is refused on a lawful ground, the response will explain the refusal and record it where required.</p>
        <p>Because cart data is stored on the visitor's own device, clearing browser storage removes that local cart. Requests concerning Stripe-held payment data may require direct verification through Stripe because payment credentials are not held in the storefront form.</p>
      </section>

      <section>
        <h2>Privacy complaints</h2>
        <p>First identify the information, the event and the remedy requested by email. We will examine the available storefront, payment-session and correspondence records. This internal process does not prevent a person from contacting Hong Kong's Privacy Commissioner for Personal Data or using another non-excludable remedy.</p>
      </section>
    </PolicyLayout>
  );
}

export default ConsumerDataRights;
